module.exports = __webpack_public_path__ + "images/icon-144x144-9b339156318a2d536e50183c498fa9ff.png";